export const matchesPathname = (pathname: string): boolean => {
  return location.pathname === pathname
}
